import React, { useEffect, useState } from "react";
import api from "../api";
import Attendance from "./Attendance";
import useAuth from "../../hooks/useAuth";

export default function AttendanceWrapper() {
  const [siteId, setSiteId] = useState(null);
  const [loading, setLoading] = useState(true);
  const {auth} = useAuth();

  useEffect(() => {
    if (!auth?.empId) return;

    const fetchSiteId = async () => {
      try {
        console.log("auth =", auth);

        // 1️⃣ Get user → branch
        const userRes = await api.get(`/users/user/${auth.empId}`);
        const branchName = userRes.data.branch;

        if (!branchName) throw new Error("Branch missing for user");

        // 2️⃣ Get branch → siteId
        const branchRes = await api.get(`/branches/branch/${branchName}`);
        const resolvedSiteId = branchRes.data._id;

        if (!resolvedSiteId) throw new Error("siteId missing for branch");
        console.log(resolvedSiteId);
        setSiteId(resolvedSiteId);
      } catch (err) {
        console.error("Failed to resolve siteId:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSiteId();
  }, [auth.empId]);

  if (loading) return <div>Loading...</div>;
  if (!siteId) return <div>No site assigned</div>;

  return (
    <Attendance
      empId={auth.empId}
      siteId={siteId}   
      shiftId={1}
    />
  );
}
